/**
 * Normaliza el cuerpo del error cuando la petición usó responseType: 'blob'.
 * Axios devuelve errores JSON del backend como Blob; esto los convierte a objeto o string
 * para que getErrorMessage pueda leer response.data.message.
 */
export const normalizeBlobErrorResponse = async (error) => {
  const response = error?.response;
  const config = error?.config;

  if (!response || config?.responseType !== 'blob' || response.status < 400) {
    return error;
  }

  const { data } = response;

  if (!(data instanceof Blob)) {
    return error;
  }

  try {
    const text = await data.text();

    try {
      response.data = JSON.parse(text);
    } catch {
      response.data = text;
    }
  } catch {
    // Se conserva response.data sin modificaciones ante errores inesperados al leer el Blob
  }

  return error;
};
